import React from "react";
import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react";

import VisibilityIcon from "@mui/icons-material/Visibility";

import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import sign_password_icon from "../../assets/images/icons/signin_password_icon.svg";

export const PasswordInput = (props) => {
  const [show, setShow] = React.useState(false);

  return (
    <InputGroup size="lg">
      <InputLeftElement
        pointerEvents="none"
        sx={{ paddingTop: "15px" }}
        children={<img src={sign_password_icon} />}
      />

      <Input
        pr="4.5rem"
        type={show ? "text" : "password"}
        placeholder="Enter password"
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        name={props?.name || "password"}
        isInvalid={props.isInvalid}
      />
      <InputRightElement
        // width="4.5rem"
        sx={{ paddingTop: "13px", _hover: { cursor: "pointer" } }}
        onClick={() => setShow(!show)}
      >
        {show ? <VisibilityOffIcon /> : <VisibilityIcon />}
      </InputRightElement>
    </InputGroup>
  );
};

export default PasswordInput;
